// Add your custom JS here.
(function ($) {

    function getScrollbarWidth() {
        const div = $(
            '<div style="width:50px;height:50px;overflow:hidden;position:absolute;top:-200px;left:-200px;"><div style="height:100px;"></div>'
        );
        // Append our div, do our calculation and then remove it
        $("body").append(div);
        const w1 = $("div", div).innerWidth();
        div.css("overflow-y", "scroll");
        const w2 = $("div", div).innerWidth();
        $(div).remove();
        return w1 - w2;
    }

    function updateScrollbarWidth() {
        const scrollbar_width = getScrollbarWidth();
        $("body").css("--scrollbar-width", scrollbar_width + "px");
    }

    updateScrollbarWidth();
    $(window).on("resize", function () {
        updateScrollbarWidth();
    });

    // FOR MEGAMENU
    document.documentElement.style.setProperty('--scrollPosition', (document.documentElement.scrollTop || document.body.scrollTop) + "px");
    document.addEventListener('scroll', function(e) {
        document.documentElement.style.setProperty('--scrollPosition', (document.documentElement.scrollTop || document.body.scrollTop) + "px");
    });

    $(document).on('click', '.e-n-menu-mobile-header__back', function() {
        $('.sub-menu-opened .elementor-link-list__parent-link__collapse')[0].click();
    });

    $(document).on('click', '.e-n-menu-mobile-header .btn-close-menu', function() {
        $('.e-n-menu-toggle').trigger('click');
    });

    $(document).on('click', '.e-n-menu-toggle', function() {
        const opened = $(this).attr("aria-expanded");
        if (opened == 'true') {
            $('body').addClass('menu-opened');
        } else {
            $('body').removeClass('menu-opened');
        }
    });

    // $(document).on('mouseenter', '.e-n-menu-item:has(.e-n-menu-content)', function() {
    //     $('header').addClass('menu-opened-bg');
    // });
    // $(document).on('mouseleave', '.e-n-menu-item:has(.e-n-menu-content)', function() {
    //     $('header').removeClass('menu-opened-bg');
    // });
    // END MEGAMENU

    // Handle Axeptio
    window._axcb = window._axcb || [];
    window._axcb.push(function(sdk) {
        sdk.on('ready', function () {
            const cookiesButtons = document.querySelectorAll('a[showcookies="true"], span[showcookies="true"]');
            if (cookiesButtons) {
                Array.from(cookiesButtons).forEach(function(button) {
                    button.addEventListener('click', () => {
                        window.showAxeptioButton();
                        window.openAxeptioCookies();
                    });
                })
            }
        });
        sdk.on('cookies:complete', function () {
            window.hideAxeptioButton();
        });
    });

})(jQuery);

export {}; // avoid tree-shaking from Rollup and make sure the file is builded